module.exports = [
    {
        value: 'equipment_size',
        name: 'Equipment Size',
        formatter: 'fixedInt',
    },
    {
        value: 'weekly_volume',
        name: 'Weekly Volume',
        formatter: 'fixedInt',
    },
    {
        value: 'one_way_rate',
        name: 'One Way Rate',
        formatter: 'fixedFloat',
    },
    {
        value: 'round_trip_rate',
        name: 'Round Trip Rate',
        formatter: 'fixedFloat',
    },
];
